import _ from "lodash";
import React, { useEffect } from "react";
import classes from "./UseTemplateModal.scss";
import UIModal from "UIComponents/UIModal";
import TheatreMode from "UIComponents/TheatreMode";
import UseTemplateHeader from "./components/UseTemplateHeader";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { markAttachmentAsRead } from "modules/Services";
import { connect } from "react-redux";
import { markAttachmentAnnotationAsRead } from "Projects/modules/ProjectModules";

const UseTemplateModal = ({
  attachment,
  open,
  onClose,
  rightActionButton,
  shouldShowTabIcon,
  wrapInModal,
  attachmentBottomComponent,
  showSimilarityIndex,
  onPdftronUpdateSuccessful,
  isPDFAnnotationEnabled,
  markAttachmentAsRead,
  projectId,
  markAttachmentAnnotationAsRead,
  projectGroupType,
  studentAssignmentId,
}) => {
  useEffect(() => {
    if (!attachment?.isRead && !_.includes(attachment?.id, "NEW_")) {
      markAttachmentAsRead({ id: attachment?.id });
    }

    // _.isNil is used to check for non boolean falsy values like null, undefined
    // Only run mutation when isAnnotationRead is false
    if (
      !_.isNil(attachment?.isAnnotationRead) &&
      !attachment?.isAnnotationRead
    ) {
      markAttachmentAnnotationAsRead({
        id: attachment?.id,
        projectId,
        projectGroupType,
      });
    }
  }, [
    attachment,
    markAttachmentAsRead,
    projectId,
    markAttachmentAnnotationAsRead,
  ]);

  const mediaData = {
    attachments: [_.omit(attachment, ["presetAttachment"])],
    attachmentId: _.get(attachment, "id", ""),
    isPost: true,
  };

  const attachmentData = _.isEqual(
    _.get(attachment, "metadata.serviceType"),
    "MICROSOFT"
  )
    ? { ...attachment, url: _.get(attachment, "metadata.viewUrl") }
    : attachment;

  return (
    <ConditionalWrapper
      condition={wrapInModal}
      wrapper={({ children }) => (
        <UIModal isOpen={open} isFullScreen={true}>
          {children}
        </UIModal>
      )}
    >
      <div className={classes.container}>
        <UseTemplateHeader
          title={attachment.name}
          onClose={onClose}
          shouldShowTabIcon={shouldShowTabIcon}
          rightActionButton={rightActionButton}
          url={attachment.url}
          attachmentBottomComponent={() =>
            _.isFunction(attachmentBottomComponent) &&
            attachmentBottomComponent({
              showSimilarityOnHeader: true,
            })
          }
          showSimilarityIndex={showSimilarityIndex}
          attachment={attachment}
        />
        <div className={classes.content}>
          {_.get(attachment, "mimeType", "") === "application/pdf" &&
          isPDFAnnotationEnabled ? (
            <TheatreMode
              currentMediaData={mediaData}
              setShowGiveFeedbackModal={true}
              shouldShowGiveFeedbackButton={true}
              onPdftronUpdateSuccessfullly={onPdftronUpdateSuccessful}
              studentSubmissionId={studentAssignmentId}
            />
          ) : (
            <TheatreMode
              currentMediaData={mediaData}
              studentSubmissionId={studentAssignmentId}
            />
          )}
        </div>
      </div>
    </ConditionalWrapper>
  );
};

UseTemplateModal.defaultProps = {
  wrapInModal: true,
  isPDFAnnotationEnabled: false,
};

const mapActionCreators = {
  markAttachmentAsRead,
  markAttachmentAnnotationAsRead,
};

export default connect(null, mapActionCreators)(UseTemplateModal);
